module.exports = __webpack_public_path__ + "animationpaths/a1547f8b64ad4872d82ab88fbedd1e2b.data";